export class PwaMainNav extends HTMLElement {
  static tagName = "pwa-main-nav"

  #nav
  #toggles
  #handleOutsideClick = (event) => {
    if (!this.contains(event.target)) {
      this.#close()
    }
  }

  #toggleMenu = (event) => {
    if (this.hasAttribute("open")) {
      this.#close()
    } else {
      this.setAttribute("open", "")
      event.target.setAttribute("aria-expanded", "true")
    }
  }

  connectedCallback() {
    this.#nav = this.querySelector("nav")
    this.#toggles = [...this.querySelectorAll("button[type=button]")]
    if (!this.#nav || this.#toggles.length === 0) return
    for (const toggle of this.#toggles) {
      toggle.addEventListener("click", this.#toggleMenu)
    }
    document.addEventListener("click", this.#handleOutsideClick)
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.#handleOutsideClick)
  }

  #close() {
    this.removeAttribute("open")
    for (const toggle of this.#toggles) {
      toggle.setAttribute("aria-expanded", "false")
    }
  }
}
